import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  VipDashboardResponse,
  VipQuestLogsQuery,
  VipQuestLogsResponse,
  VipStatsPeriod,
  VipStatsResponse,
} from './vip.models';
import { VipService } from './vip.service';

@Injectable({ providedIn: 'root' })
export class VipFacade {
  constructor(private readonly vipService: VipService) {}

  getStats(period: VipStatsPeriod = 'all'): Observable<VipStatsResponse> {
    return this.vipService.getStats(period);
  }

  getDashboard(userId: number): Observable<VipDashboardResponse> {
    return this.vipService.getDashboard(userId);
  }

  getQuestLogs(userId: number, query: VipQuestLogsQuery): Observable<VipQuestLogsResponse> {
    return this.vipService.getQuestLogs(userId, query);
  }

  getErrorMessage(error: HttpErrorResponse, fallbackMessage: string): string {
    if (typeof error.error?.message === 'string' && error.error.message.length > 0) {
      return error.error.message;
    }

    if (typeof error.message === 'string' && error.message.length > 0) {
      return error.message;
    }

    return fallbackMessage;
  }
}
